module.exports = __webpack_public_path__ + "top-img.png?d4696963f47efc8c4c9bd5e3b237c708";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ProductAndService/MOBEC/top-img.png
// module id = 169
// module chunks = 0